<template>
  <div :class="['studio-container', 'studios-com', { 'not-admin': !admin }]">
    <div class="admin-header-sec">
      <!-- for Admin -->
      <h1 v-if="admin" class="admin-title-sec">{{ $t('studios') }}</h1>
      <!-- end for Admin -->
      <div class="search-add-sec">
        <input type="text" :placeholder="$t('name')" @input="filterStudio" />
        <!-- for Admin -->
        <img width="50" @click.stop.prevent="handleButtonClick()" v-if="admin"
          :src="fit20.storageBaseUrl + '/static/icons/%2B.png'" />
        <!-- end for Admin -->

      </div>
    </div>
    <div class="studios" ref="adminStudiosSec" id="admin_studios_sec">
      <div class="studio-card" v-for="studio in filteredStudios" :key="studio.id"
        @click.stop.prevent="handleButtonClick(studio.id)">
        <a :href="'#'" :id="studio.id">
          <div class="flex card-div">
            <img v-if="studio.photo" loading="lazy"
              :src="fit20.storageBaseUrl + '/studio/' + studio.id + '.png?generation=0'" />
            <img v-if="!studio.photo" :src="fit20.defaultStudioImg" loading="lazy" />
            <p class="item-name">{{ studio.displayName }}</p>
          </div>
          <div class="right-bottom">
            <img v-if="studio.active" :src="fit20.storageBaseUrl + '/studio/active.svg'" />
            <span v-if="studio.active" class="right-bottom-center">{{ studio.memberCount }}</span>
            <img class="inactive-studio" v-if="!studio.active" :src="fit20.storageBaseUrl + '/studio/inactive.png'" />
          </div>
        </a>
      </div>

    </div>
  </div>
</template>

<script>
import { formattedDateTime } from '../actions/global';
export default {
  name: 'Studios',
  components: {},
  props: ["fit20", "admin", "selectTab", "admin_fit20", "formatDate"],
  data() {
    return {
      filteredStudios: [],
      inputValue: ''
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      if (string) {
        return string[0].toUpperCase() + string.slice(1);
      } else {
        return '';
      }
    },
    async editStudio(id) {
      const res = await fetch(this.fit20.baseUrl + "/api/studios/" + id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
      let result = await res.json();
      if (result.msg) {
        if (result.msg == "invalid-token") {
          this.clearLocalStorage();
        }
        alert(this.$t(result.msg));
      } else {
        this.admin_fit20.studio = result;
      }
    },
    async getStudio(id) {
      try {
        const res = await fetch(this.fit20.baseUrl + "/api/studios/" + id + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
        let result = await res.json();
        if (result.msg) {
          if (result.msg == "invalid-token") {
            this.clearLocalStorage();
          }
          alert(this.$t(result.msg));
        } else {
          this.fit20.studio = result;
        }
      } catch (err) {
        console.log({ err });
        this.fit20.errors.push("Error in Studios.vue in getStudio " + formattedDateTime());
        this.fit20.errors.push(JSON.stringify({
          message: err.message,
          stack: err.stack,
          name: err.name,
        }) + " " + formattedDateTime());
        this.fit20.errMsgs.push({ id: Date.now(), type: 'err', msg: this.$t('general-err-msg') });
      }
      if (this.fit20.studio && this.fit20.studio.machines.length > 0) {
        let ids = [];
        this.fit20.studio.machines.forEach(machine => ids.push(machine.id));
        const results = await fetch(this.fit20.baseUrl + "/api/machines/" + "[" + ids + "]" + "?accessToken=" + localStorage.getItem('access_token') + "&user=" + this.fit20.user.email);
        this.fit20.studioMachines = await results.json();
        this.fit20.studioMachines = this.fit20.studioMachines.sort((a, b) => a.order - b.order);
        // Handling the new fit20 machines ids to make them act like the old one  >>>>>>>>>>>>>>>>>>>>
        let newLegPress = this.fit20.studioMachines.find(machine => machine.id == this.fit20.newLegPress);
        if (newLegPress) {
          newLegPress.id = '1001';
          this.fit20.studio.machines.find(machine => machine.id == this.fit20.newLegPress)
        }


        this.fit20.sensorsMachines = JSON.parse(JSON.stringify(this.fit20.studioMachines.filter(machine => this.fit20.machineWithSensor.includes(machine.id))));
        // console.log('??????????????????????????????');
        // console.log(this.fit20.studioMachines);
        if (this.fit20.sensorsMachines.length > 0) {
          // add the ip address of old leg press to the new leg press
          // let findOldLegPressInSensorsMachines =
          //   this.fit20.sensorsMachines.find(machine => machine.id == "1001");
          // if (newLegPress && findOldLegPressInSensorsMachines) {
          //   let findIp = this.fit20.studio.machines.find(machineX => machineX.id == "1001");
          //   if (findIp) {
          //     findOldLegPressInSensorsMachines.ipAddress = findIp.ipAddress;
          //   }

          // }


          this.fit20.sensorsMachines.forEach(machine => {
            let findIp = this.fit20.studio.machines.find(machineX => machineX.id == machine.id);
            if (findIp) {
              machine.ipAddress = findIp.ipAddress;
            }
            // if (!machine.name.includes('Row') && !machine.name.includes('Torso') && !machine.name.includes('Chair')) {
            if (!machine.ipAddress) {
              this.$set(machine, 'connecting', false);
            } else {
              this.$set(machine, 'connecting', true);
            }
            this.$set(machine, 'connected', false);
          })
          // handel the ip address of the new leg press
          if (newLegPress) {
            let newLegPressInStudio = this.fit20.studio.machines.find(machine => machine.id == this.fit20.newLegPress);
            if (newLegPressInStudio) {
              let oldLegPress = this.fit20.sensorsMachines.find(machineX => machineX.id == "1001");
              if (oldLegPress) {
                oldLegPress.ipAddress = newLegPressInStudio.ipAddress;
              }
            }
          }
          if (this.fit20.sensorsMachines.length > 0) {
            this.fit20.sensorsMachines.map(async machine => {
              if (machine.ipAddress) {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 7000);
                try {
                  let response = await fetch(this.fit20.hostProtocol + machine.ipAddress + ':' + this.fit20.MSA_port + '/identify', {
                    signal: controller.signal,
                    method: 'POST',
                    body: JSON.stringify({ machineId: machine.id, machineName: machine.name.includes('duction') ? 'Adduction / abduction' : machine.name }),
                  });
                  const data = await response.json();
                  this.$set(machine, 'connecting', false);
                  if (data.machineId) {
                    this.$set(machine, 'connected', true);
                  }
                  clearTimeout(timeoutId);
                } catch (err) {
                  if (err.name === 'AbortError') {
                    this.fit20.errors.push("Error in Studios.vue in get studio. " + formattedDateTime());
                    this.fit20.errors.push('Machine: ' + machine.name + " " + formattedDateTime());
                    this.fit20.errors.push('AbortError, The IP Address not found in the network or slow wifi' + " " + formattedDateTime());
                    this.$set(machine, 'connecting', false);
                  } else {
                    this.$set(machine, 'connecting', false);
                    this.fit20.errors.push("Error in Studios.vue in get studio " + formattedDateTime());
                    this.fit20.errors.push('Machine: ' + machine.name + " " + formattedDateTime());
                    this.fit20.errors.push(JSON.stringify({
                      message: err.message,
                      stack: err.stack,
                      name: err.name,
                    }) + " " + formattedDateTime());
                  }
                }
              }
            })
          }
        }
      }
    },
    async handleButtonClick(id) {
      if (this.admin) {
        if (id) {
          await this.editStudio(id);
        } else {
          this.admin_fit20.studio = {
            id: "new_studio",
            displayName: '',
            name: "",
            users: [],
            machines: [],
            openDate: this.formatDate(new Date(Date.now())),
            gateway: "",
          }
        }
        this.selectTab('#admin_studio');
      } else {
        let checkActiveSession = Object.keys(this.fit20.tabs).find(key => this.fit20.tabs[key].active);
        if (checkActiveSession) {
          if (window.confirm(this.$t('active-session-warning'))) {
            this.fit20.tabs = {
              tab2: { active: false, action: '', exercisesControl: [] },
              tab3: { active: false, action: '', exercisesControl: [] },
              tab4: { active: false, action: '', exercisesControl: [] },
            };
            this.fit20.currentMembers = [[], [], []],
              await this.getStudio(id);
            this.selectTab('#members', 'tab_id1');
          }
        } else {
          this.fit20.tabs = {
            tab2: { active: false, action: '', exercisesControl: [] },
            tab3: { active: false, action: '', exercisesControl: [] },
            tab4: { active: false, action: '', exercisesControl: [] },
          };
          this.fit20.currentMembers = [[], [], []],
            await this.getStudio(id);
          this.selectTab('#members', 'tab_id1');
        }
      }
    },
    filterStudio(event) {
      this.inputValue = event;
      let searchWord = event.target.value.toLowerCase().trim()
      if (searchWord.length > 0) {
        this.filteredStudios =
          this.admin ? this.fit20.studios.filter(studio => studio.name.includes(searchWord)) : this.fit20.studios.filter(studio => studio.name.includes(searchWord) && studio.active && studio.displayName);
      } else {
        this.filteredStudios = this.admin ? [...this.fit20.studios] : this.fit20.studios.filter(studio => studio.active && studio.displayName)
      }
    },
  },
  mounted: function () {
    // Scroll the element to the top using Vue's ref
    const adminStudiosSec = this.$refs.adminStudiosSec;
    if (adminStudiosSec) {
      adminStudiosSec.scrollTop = 0;
    }

    if (this.inputValue && this.inputValue.length > 0) {
      this.filterStudio(this.inputValue);
    }
  },
  created: function () {
    if (this.inputValue && this.inputValue.length > 0) {
      this.filterStudio(this.inputValue);
    }
  },
  watch: {
    'fit20.studios': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (!this.inputValue && this.admin) {
          this.filteredStudios = [...newVal];
        } else if (!this.inputValue && !this.admin) {
          this.filteredStudios = newVal.filter(studio => studio.active && studio.displayName);
        }
      }
    },
    'fit20.selectedTabHref': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        if (newVal == '#admin_studios') {
          $('#admin_studios_sec').scrollTop(0);
        }
      }
    }
  }
};
</script>

<style>
.studios-com.studio-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.studios-com.not-admin {
  top: 100px;
}

.studios-com .search-add-sec {
  display: flex;
  justify-content: space-between;
}

.studios-com .search-add-sec img {
  width: 50px;
  min-width: 0px;
  min-height: 0px;
}

.studios-com.studio-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 33%;
  /* z-index: 9999999999; */

}



.studios-com .right-bottom {
  position: absolute;
  width: 35%;
  bottom: -5px;
  right: 2px;
  max-height: 65px;
  max-width: 115px;
}

.studios-com .right-bottom-center {
  color: var(--fit20-green);
  position: absolute;
  /* width: 40%; */
  left: 50%;
  top: 40%;
  transform: translate(-50%, 0);
}

.studios-com img.inactive-studio {
  width: 30%;
  position: absolute;
  z-index: -99;
  bottom: 4px;
  right: 10px;
  max-height: 105px;
  max-width: 62px;
}
</style>
